import React from 'react';
import { ArrowRight } from 'lucide-react';
import KpiLogPage from './KpiLogPage';
import KpiHistoryPage from './KpiHistoryPage';

export const ActionLogPage = () => (
  <KpiLogPage
    kpi="action"
    apiPath="/locker/action"
    eyebrow="Action · Log a round"
    title="How well did you commit today?"
    subtitle="The gap between knowing and doing is where rounds are won."
    icon={ArrowRight}
  />
);

export const ActionHistoryPage = () => (
  <KpiHistoryPage
    kpi="action"
    apiPath="/locker/action"
    newPath="/locker/action/new"
    eyebrow="Action · History"
    icon={ArrowRight}
  />
);
